// src/config/apiConfig.js

// const API_BASE_URL = 'http://192.168.1.8:3004/transdier';  // Aquí defines tu URL base
const API_BASE_URL = 'https://srv748061.hstgr.cloud/transdier';  // Aquí defines tu URL base

export default API_BASE_URL;
